<clr-dropdown [clrCloseMenuOnItemClick]="true">
  <input clrDropdownTrigger class="clr-input"
         aria-label="Suche Komponenten..."
         id="search_input"
         type="text"
         placeholder="Suche nach Zeichnungsnummer..."
         (keyup)="onKeyUp($event)" />
  <cds-icon shape="angle"></cds-icon> (mind. drei Zeichen eingeben)
  <clr-dropdown-menu *clrIfOpen>
    <div *ngFor="let components of foundComponents" clrDropdownItem (click)="addComponent(components.technical_drawing)">{{ components.technical_drawing }} - {{ components.name }}</div>
  </clr-dropdown-menu>
</clr-dropdown>
